import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function WhoIsItFor() {
  const {
    t
  } = useLanguage();
  const businessTypes = [{
    icon: '⚖️',
    name: t('who.type1')
  }, {
    icon: '🏥',
    name: t('who.type2')
  }, {
    icon: '🚗',
    name: t('who.type3')
  }, {
    icon: '🏢',
    name: t('who.type4')
  }];
  return <section className="bg-brand-bg py-16 md:py-24" data-id="element-225">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-226">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-primary mb-4" data-id="element-228">
            {t('who.title')}
          </h2>
        </motion.div>

        <motion.div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-229">
          <div className="md:hidden text-sm text-gray-500 py-3 bg-gray-50 flex items-center justify-center border-b border-gray-100" data-id="element-230">
            <span className="mr-2" data-id="element-231">←</span> {t('solution.scroll')}{' '}
            <span className="ml-2" data-id="element-232">→</span>
          </div>
          <div className="overflow-x-auto" data-id="element-233">
            <table className="w-full min-w-[500px] border-collapse" data-id="element-234">
              <thead data-id="element-235">
                <tr className="bg-brand-navy text-white" data-id="element-236">
                  <th className="py-4 px-6 text-left font-semibold text-lg" data-id="element-237">
                    {t('who.th1')}
                  </th>
                  <th className="py-4 px-6 text-center font-semibold text-lg w-48" data-id="element-238">
                    {t('who.th2')}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-239">
                {businessTypes.map((type, index) => <tr key={index} className="hover:bg-brand-alt/30 transition-colors" data-id="element-240">
                    <td className="py-5 px-6 flex items-center space-x-4" data-id="element-241">
                      <span className="text-2xl" data-id="element-242">{type.icon}</span>
                      <span className="text-lg font-medium text-brand-text" data-id="element-243">
                        {type.name}
                      </span>
                    </td>
                    <td className="py-5 px-6 text-center" data-id="element-244">
                      <div className="flex items-center justify-center space-x-2 text-green-600 font-bold bg-green-50 py-1.5 px-3 rounded-full inline-flex" data-id="element-245">
                        <CheckCircle2 className="w-5 h-5" data-id="element-246" />
                        <span data-id="element-247">{t('who.yes')}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.div className="text-center bg-brand-alt py-6 px-8 rounded-xl border border-brand-primary/20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-248">
          <p className="text-xl font-bold text-brand-navy" data-id="element-249">{t('who.bottom')}</p>
        </motion.div>
      </div>
    </section>;
}